import { createSlice } from "@reduxjs/toolkit";
import { REHYDRATE } from "redux-persist";

const getInitialState = () => {
  try {
    const persistedState = localStorage.getItem("persist:waste-admin-data");
    const token = localStorage.getItem("waste-admin-token");
    if (persistedState) {
      const parsed = JSON.parse(persistedState);
      const authState = JSON.parse(parsed.auth);
      if (authState && token) {
        return {
          user: authState.user,
          token: token,
          isAuthenticated: true,
          loading: false,
          error: null,
        };
      }
    }
  } catch (error) {
    console.error("Error loading persisted state:", error);
  }
  return {
    user: null,
    token: null,
    isAuthenticated: false,
    loading: false,
    error: null,
  };
};

const initialState = getInitialState();

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    //* Set user (login) - updated to handle the nested API response
    setUser: (state, action) => {
      const responseData = action.payload;

      state.user = responseData;
      state.token = responseData.token;
      state.isAuthenticated = true;
      state.loading = false;
      state.error = null;

      //* Storing the user data in local storage
      localStorage.setItem("waste-admin-token", responseData.token);
      localStorage.setItem(
        "persist:waste-admin-data",
        JSON.stringify(responseData)
      );
    },

    //* Clear user (logout)
    clearUser: (state) => {
      state.user = null;
      state.token = null;
      state.isAuthenticated = false;
      state.loading = false;
      state.error = null;
        localStorage.removeItem("waste-admin-token");
        localStorage.removeItem("persist:waste-admin-data");
    },

    //* Update user info
    updateUser: (state, action) => {
      state.user = { ...state.user, ...action.payload };
    },

    // Set loading state
    setLoading: (state, action) => {
      state.loading = action.payload;
    },

    // Set error state
    setError: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
  },
  extraReducers: (builder) => {
    // Handle rehydration from redux-persist
    builder.addCase(REHYDRATE, (state, action) => {
      if (action.payload && action.payload.auth) {
        return {
          ...state,
          ...action.payload.auth,
          loading: false,
          error: null,
        };
      }
      return state;
    });
  },
});

export const { setUser, clearUser, updateUser, setLoading, setError } =
  authSlice.actions;

export default authSlice.reducer;

// Selectors
export const selectUser = (state) => state.auth.user;
export const selectToken = (state) => state.auth.token;
export const selectIsAuthenticated = (state) => state.auth.isAuthenticated;
export const selectAuthLoading = (state) => state.auth.loading;
export const selectAuthError = (state) => state.auth.error;

// Additional useful selectors
export const selectUserFullName = (state) => {
  const user = state.auth.user;
  return user ? `${user.first_name} ${user.last_name}` : "";
};

export const selectUserEmail = (state) => state.auth.user?.email;
export const selectUserId = (state) => state.auth.user?.id;
